<template>
  <div
    class="sidebar sidebar--main align-items-center"
    :class="[{ 'in' : sidebar }]"
  >
    <navigation
      :items="doMenuFormat(items)"
      :key="items.length"
    ></navigation>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue';
import { mapState } from 'vuex';

export default {
  name: 'sidebar',
  components: {
    Navigation,
  },
  computed: {
    ...mapState({
      sidebar: state => state.layout.sidebar,
    }),
    items() {
      return this.$store.state.menus.entries
        .filter(item => {
          return item.parent === 'sidebar';
        })
        .concat(this.additionalItems);
    },
  },
  data() {
    return {
      menuAutoLoadTypes: false,
      additionalItems: [],
    };
  },
  created() {
    this.$store.dispatch('menus/get');
    if (this.menuAutoLoadTypes) {
      this.loadTypesToMenu();
    }
  },
  methods: {
    loadTypesToMenu() {
      this.$store.dispatch('types/get', {
        callback: data => {
          const menu = [];
          data.forEach(item => {
            menu.push({
              name: `objects-type-index`,
              label: item.plural,
              icon: item.icon,
              params: {
                type: item.slug,
              },
            });
          });
          this.additionalItems = this.additionalItems.concat(menu);
        },
      });
    },
  },
};
</script>

<style lang="scss">
.sidebar--main {
  background-color: $inverse;
  border-right: 1px solid $muted;
  max-width: $sidebar-width;
  min-width: $sidebar-width;
  position: fixed;
  top: $header-height;
  bottom: 0;
  left: -1 * $sidebar-width;
  transition: ease-in-out left 0.3s;
  z-index: 1;
  &.in {
    left: 0;
  }
}
</style>
